module.exports = "/images/vessel-6.jpg";